export default "__VITE_ASSET__BAerfcUt__"